import { useEffect } from 'react'
import { useAtomValue } from 'jotai'
import { accessTokenAtom } from 'services/token/token.model'
import { initPushNotifications } from './pushNotifications'

// Initializes push notifications whenever a session is present — covers both
// a fresh login (atom write) and an app start with a persisted session.
export const usePushNotifications = () => {
  const accessToken = useAtomValue(accessTokenAtom)

  useEffect(() => {
    if (!accessToken) {
      return
    }

    initPushNotifications(accessToken).catch((error) => {
      console.error('Failed to init push notifications:', error)
    })
  }, [accessToken])
}
